module.exports = __webpack_public_path__ + "static/img/question3-1.ce6c3a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question3-1.png
// module id = fIEo
// module chunks = 1